module.exports = __webpack_public_path__ + "media/site_templates/www.tv-installation.com.au/images/testimonials-f46e99462da1a3200c0477b622da0afb.jpg";